import { useTaskContext } from "hooks/tasks";
import { useState } from "react";
import { useWorkItemMetadataTabs, useWorkItemMetadataValues } from "hooks/metadata";
import Metadata from "components/metadata";
import { IMetadataOwner, IMetadataTab } from "models/metadata";
import { GuidOrNumber } from "models/common";

const TaskMetadata = () => {    
    //-------------------- HOOKS --------------------    
    const taskContext = useTaskContext();
    const { task, updateTaskOverview } = taskContext;

    const owner: IMetadataOwner = {
        workItemId: task?.workItem?.id ?? 0,
        taskId: task?.id
    };

    const [ tabs, loadingTabs ] = useWorkItemMetadataTabs(owner);
    const [ getMetadata, setMetadata ] = useWorkItemMetadataValues(owner);

    const [ loadingValues, setLoadingValues ] = useState<boolean>(false);
    
    //-------------------- FUNCTIONS --------------------
    const handleCheckAlert = (tab: IMetadataTab) => {
        return task?.requirements?.some(r => {

            // Check if the requirement's tabKey is 'metadata'
            if (r.tabKey !== 'metadata') {
                return false;
            }
            const tabName = tab.name.toLowerCase();

            const requirmentParts = r.description.split(' - ');
            const reqTabName = requirmentParts.length > 1 ? requirmentParts[0].toLowerCase().trim() : r.description.toLowerCase().trim();

            return (reqTabName === tabName) && r.isDone === false;
        }) ?? false;
    };

    const handleGetMetadata = async (id: GuidOrNumber) => {
        if (!task) return null;
        try {
            setLoadingValues(true);
            const result = await getMetadata(id);
            return result?.value;
        } finally {
            setLoadingValues(false);
        }
    };

    const handleSetMetadata = async (id: GuidOrNumber, originalValue: any, newValue: any, isValid: boolean) => {
        if (!task) return null;
        if (isValid) {
            const result = await setMetadata(id, originalValue, newValue);
            /// Refresh task for requirements.
            updateTaskOverview();
            return result?.value;
        }

        return null;
    }
    
    //-------------------- RENDER --------------------
    return (
        <Metadata 
            loading={loadingTabs}
            loadingValues={loadingValues}
            tabs={tabs}
            onLoadValues={handleGetMetadata}
            onUpdateValue={handleSetMetadata}
            checkAlert={handleCheckAlert}
        />        
    );
};

export default TaskMetadata;